import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors.tsx";
import ProfilPhoto from "../../assets/images/ma-tete.jpg";
import AKSite from "../../assets/images/ak-site.png";
import LMS from "../../assets/images/LMS.png"
import CVImage from "../../assets/images/cv-preview.png"; // Aperçu de ton CV

// Icons logos (tu peux utiliser des images ou des SVG)
import FigmaLogo from "../../assets/images/Figma.png";
import ReactLogo from "../../assets/images/React.png";
import MySQLLogo from "../../assets/images/mysql.png";
import JSLogo from "../../assets/images/JavaScript.png";
import PHPLogo from "../../assets/images/php.png";
import PrestaShopLogo from "../../assets/images/Prestashop.png";
import SymfonyLogo from "../../assets/images/Symfony.png";

const PageContainer = styled.div`
    padding-top: 150px;
    background-color: ${colors.white};

    @media (max-width: 768px) {
        padding-top: 100px;
    }
`;

// Header avec photo et nom
const HeaderSection = styled.div`
    background-color: ${colors.white};
    border: solid 7px ${colors.dark_red};
    border-radius: 20px;
    padding: 30px;
    margin: 50px 5% 30px;
    display: flex;
    align-items: center;
    gap: 40px;
    box-shadow: 8px 8px ${colors.dark_red};

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        padding: 20px;
        margin: 30px 5%;
        box-shadow: 5px 5px ${colors.dark_red};
        border: solid 5px ${colors.dark_red};
    }
`;

const PhotoWrapper = styled.div`
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
    border: solid 5px ${colors.dark_red};
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: 768px) {
        width: 120px;
        height: 120px;
    }
`;

const HeaderInfo = styled.div`
    flex: 1;
`;

const Name = styled.h1`
    font-family: "Archivo Black", sans-serif;
    font-size: 42px;
    margin: 0 0 10px 0;
    color: ${colors.black};

    @media (max-width: 768px) {
        font-size: 28px;
    }
`;

const JobTitle = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 24px;
    margin: 0 0 20px 0;
    color: ${colors.black};

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const NavButtons = styled.div`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

const NavButton = styled.button`
    background-color: ${({ $active }) => ($active ? colors.dark_red : colors.white)};
    color: ${({ $active }) => ($active ? colors.white : colors.dark_red)};
    border: solid 3px ${colors.dark_red};
    border-radius: 20px;
    padding: 8px 20px;
    font-family: "Archivo Black", sans-serif;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background-color: ${colors.dark_red};
        color: ${colors.white};
        transform: translateY(-2px);
    }

    @media (max-width: 768px) {
        font-size: 12px;
        padding: 6px 15px;
    }
`;

// Section Card
const SectionCard = styled.div`
    background-color: ${colors.white};
    border: solid 7px ${colors.dark_red};
    border-radius: 20px;
    padding: 40px;
    margin: 30px 5%;
    box-shadow: 8px 8px ${colors.dark_red};

    @media (max-width: 768px) {
        padding: 25px;
        margin: 20px 5%;
        border: solid 5px ${colors.dark_red};
        box-shadow: 5px 5px ${colors.dark_red};
    }
`;

const SectionTitle = styled.div`
    background-color: ${colors.dark_red};
    color: ${colors.white};
    padding: 15px 40px;
    border-radius: 30px;
    text-align: center;
    font-family: "Archivo Black", sans-serif;
    font-size: 28px;
    margin: 0 auto 40px;
    width: fit-content;
    border: solid 3px ${colors.black};

    @media (max-width: 768px) {
        font-size: 20px;
        padding: 12px 30px;
        margin-bottom: 25px;
    }
`;


const ProfilText = styled.div`
    flex: 1;
    font-family: "Inter", sans-serif;
    font-size: 18px;
    line-height: 1.8;
    text-align: justify;

    p {
        margin-bottom: 20px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

// Projets Section
const ProjectsGrid = styled.div`
    display: grid;
    gap: 30px;
`;

const ProjectCard = styled.div`
    display: flex;
    gap: 30px;
    padding: 25px;
    background-color: ${colors.light_pink};
    border-radius: 15px;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
    }
`;

const ProjectImage = styled.div`
    width: 250px;
    height: 250px;
    overflow: hidden;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    @media (max-width: 768px) {
        width: 150px;
        height: 150px;
    }
`;

const ProjectInfo = styled.div`
    flex: 1;
`;

const ProjectTitle = styled.h3`
    font-family: "Archivo Black", sans-serif;
    font-size: 22px;
    margin: 0 0 15px 0;
    color: ${colors.dark_red};

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const ProjectDescription = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 15px;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const ProjectButton = styled.button`
    background-color: ${colors.dark_red};
    color: ${colors.white};
    border: solid 3px ${colors.black};
    border-radius: 10px;
    padding: 10px 25px;
    font-family: "Archivo Black", sans-serif;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 4px 4px ${colors.black};
    }

    @media (max-width: 420px) {
        margin-right: -20px;
        margin-left: -20px;
    }
`;

// Compétences Section
const CompetencesContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

const CompetenceCategory = styled.div`
    h3 {
        font-family: "Archivo Black", sans-serif;
        font-size: 20px;
        margin-bottom: 15px;
        color: ${colors.dark_red};
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            font-family: "Inter", sans-serif;
            font-size: 16px;
            margin-bottom: 10px;
            padding-left: 20px;
            position: relative;

            &:before {
                content: "•";
                position: absolute;
                left: 0;
                color: ${colors.dark_red};
                font-weight: bold;
                font-size: 20px;
            }
        }
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 18px;
        }

        ul li {
            font-size: 14px;
        }
    }
`;

const LogosGrid = styled.div`
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;

    img {
        width: 60px;
        height: 60px;
        object-fit: contain;
    }

    @media (max-width: 768px) {
        img {
            width: 50px;
            height: 50px;
        }
    }
`;

const SoftSkills = styled.div`
    margin-top: 30px;

    h3 {
        font-family: "Archivo Black", sans-serif;
        font-size: 20px;
        margin-bottom: 15px;
        color: ${colors.dark_red};
    }

    ul {
        list-style: none;
        padding: 0;

        li {
            font-family: "Inter", sans-serif;
            font-size: 16px;
            margin-bottom: 10px;
            padding-left: 20px;
            position: relative;

            &:before {
                content: "•";
                position: absolute;
                left: 0;
                color: ${colors.dark_red};
                font-weight: bold;
                font-size: 20px;
            }
        }
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 18px;
        }

        ul li {
            font-size: 14px;
        }
    }
`;

// CV Section
const CVContent = styled.div`
    display: flex;
    gap: 40px;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;

const CVPreview = styled.div`
    width: 400px;
    flex-shrink: 0;
    border: solid 5px ${colors.black};
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 5px 5px ${colors.black};

    img {
        width: 100%;
        height: auto;
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 350px;
    }
`;

const CVInfo = styled.div`
    flex: 1;
`;

const CVText = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 18px;
    line-height: 1.8;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        font-size: 16px;
        text-align: center;
    }
`;

const DownloadButton = styled.a`
    display: inline-block;
    background-color: ${colors.dark_red};
    color: ${colors.white};
    border: solid 4px ${colors.black};
    border-radius: 15px;
    padding: 15px 40px;
    font-family: "Archivo Black", sans-serif;
    font-size: 20px;
    text-decoration: none;
    box-shadow: 6px 6px ${colors.black};
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        transform: translate(-3px, -3px);
        box-shadow: 9px 9px ${colors.black};
    }

    @media (max-width: 768px) {
        font-size: 16px;
        padding: 12px 30px;
        display: block;
        text-align: center;
    }
`;

// Contact Section
const ContactContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
`;

const ContactItem = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    font-family: "Inter", sans-serif;
    font-size: 18px;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const ContactIcon = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 42px;

    @media (max-width: 768px) {
        width: 40px;
        height: 40px;
        font-size: 30px;
    }
`;

const ContactNote = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    margin-top: 20px;
    padding: 20px;
    background-color: ${colors.light_pink};
    border-radius: 10px;

    @media (max-width: 768px) {
        font-size: 14px;
        padding: 15px;
    }
`;

// Timeline Components
const TimelineContainer = styled.div`
    position: relative;
    padding: 40px 0;
    
    &:before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(
            to bottom,
            ${colors.dark_red} 0%,
            ${colors.dark_red} 90%,
            transparent 100%
        );
        transform: translateX(-50%);
    }

    @media (max-width: 768px) {
        padding: 20px 0;
        
        &:before {
            left: -500px;
        }
    }
`;

const TimelineItem = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 20px 0;
    position: relative;

    &:nth-child(even) {
        flex-direction: row-reverse;
    }

    @media (max-width: 768px) {
        flex-direction: row !important;
        padding: 15px 0;
    }
`;

const TimelineDot = styled.div`
    width: 24px;
    height: 24px;
    background-color: ${({ $current }) => ($current ? colors.dark_red : colors.white)};
    border: 4px solid ${colors.dark_red};
    border-radius: 50%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 40px;
    z-index: 2;
    box-shadow: ${({ $current }) => ($current ? '0 0 0 8px rgba(119, 61, 61, 0.2)' : 'none')};
    animation: ${({ $current }) => ($current ? 'pulse 2s infinite' : 'none')};

    @keyframes pulse {
        0%, 100% {
            box-shadow: 0 0 0 8px rgba(119, 61, 61, 0.2);
        }
        50% {
            box-shadow: 0 0 0 15px rgba(119, 61, 61, 0.1);
        }
    }

    @media (max-width: 768px) {
        left: -500px;
        top: 35px;
    }
`;

const TimelineContent = styled.div`
    width: 40%;
    background-color: ${colors.light_pink};
    padding: 25px;
    border-radius: 15px;
    border: 4px solid ${colors.dark_red};
    box-shadow: 5px 5px ${colors.dark_red};
    position: relative;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 8px 8px ${colors.dark_red};
    }

    ${TimelineItem}:nth-child(even) & {
        margin-left: auto;
    }

    ${TimelineItem}:nth-child(odd) & {
        margin-right: auto;
    }

    @media (max-width: 768px) {
        width: calc(100% - 80px);
        margin-right: 0 !important;
    }
`;

const TimelineDate = styled.div`
    font-family: "Archivo Black", sans-serif;
    font-size: 16px;
    color: ${colors.dark_red};
    margin-bottom: 10px;
    font-weight: bold;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const TimelineTitle = styled.h3`
    font-family: "Archivo Black", sans-serif;
    font-size: 22px;
    color: ${colors.black};
    margin: 0 0 15px 0;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const TimelineText = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: ${colors.black};
    margin: 0 0 15px 0;
    text-align: justify;

    &:last-of-type {
        margin-bottom: 0;
    }

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const TimelineIcon = styled.div`
    position: absolute;
    top: 20px;
    font-size: 32px;
    
    ${TimelineItem}:nth-child(odd) & {
        right: -50px;
    }

    ${TimelineItem}:nth-child(even) & {
        left: -50px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

function Portfolio() {
    const [activeSection, setActiveSection] = useState("profil");

    const scrollToSection = (section) => {
        setActiveSection(section);
    };

    return (
        <PageContainer>
            {/* Header */}
            <HeaderSection>
                <PhotoWrapper>
                    <img src={ProfilPhoto} alt="Léo Langlois" />
                </PhotoWrapper>
                <HeaderInfo>
                    <Name>Léo Langlois</Name>
                    <JobTitle>Développeur Web & Designer</JobTitle>
                    <NavButtons>
                        <NavButton
                            $active={activeSection === "profil"}
                            onClick={() => scrollToSection("profil")}
                        >
                            Profil
                        </NavButton>
                        <NavButton
                            $active={activeSection === "projets"}
                            onClick={() => scrollToSection("projets")}
                        >
                            Projets
                        </NavButton>
                        <NavButton
                            $active={activeSection === "competences"}
                            onClick={() => scrollToSection("competences")}
                        >
                            Compétences
                        </NavButton>
                        <NavButton
                            $active={activeSection === "cv"}
                            onClick={() => scrollToSection("cv")}
                        >
                            CV
                        </NavButton>
                        <NavButton
                            $active={activeSection === "contact"}
                            onClick={() => scrollToSection("contact")}
                        >
                            Contact
                        </NavButton>
                    </NavButtons>
                </HeaderInfo>
            </HeaderSection>

            {/* Profil */}
            {activeSection === "profil" && (
            <SectionCard id="profil">
                <SectionTitle>Mon Parcours</SectionTitle>
                
                {/* Timeline Container */}
                <TimelineContainer>
                    <TimelineItem>
                        <TimelineDot />
                        <TimelineContent>
                            <TimelineDate>2020 - 2024</TimelineDate>
                            <TimelineTitle>BUT Informatique</TimelineTitle>
                            <TimelineText>
                                Je m'appelle Léo, je suis développeur web diplômé d'un BUT Informatique en 2024.
                                J'ai toujours aimé comprendre comment les choses fonctionnent, démonter, tester,
                                apprendre. C'est ce qui m'a naturellement amené vers le développement, un
                                domaine où je peux créer, résoudre des problèmes, et progresser en continu.
                            </TimelineText>
                            <TimelineText>
                                Pendant mes études, j'ai eu l'occasion de travailler sur pas mal de projets en
                                groupe, ce qui m'a appris à m'organiser, à mieux communiquer, et à adopter de
                                bonnes pratiques de développement.
                            </TimelineText>
                            <TimelineIcon>🎓</TimelineIcon>
                        </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                        <TimelineDot />
                        <TimelineContent>
                            <TimelineDate>2024</TimelineDate>
                            <TimelineTitle>Début du Freelance - Clip Web</TimelineTitle>
                            <TimelineText>
                                Après l'obtention de mon diplôme, j'ai commencé à travailler en freelance. 
                                J'ai lancé ma micro-entreprise, Clip Web, pour accompagner
                                des clients sur des projets variés : sites vitrine, cartes de visite,
                                supports de communication... J'aime toucher à tout, choisir, et m'adapter aux besoins.
                            </TimelineText>
                            <TimelineIcon>💼</TimelineIcon>
                        </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                        <TimelineDot />
                        <TimelineContent>
                            <TimelineDate>2024 - 2025</TimelineDate>
                            <TimelineTitle>Projet LMS - Projets Miiro</TimelineTitle>
                            <TimelineText>
                                J'ai notamment collaboré pendant un an avec l'entreprise canadienne Projets Miiro,
                                pour qui j'ai développé un système de gestion du suivi d'apprentissage (LMS) sur
                                PrestaShop. Ce projet m'a permis d'expérimenter la gestion de projet à long
                                terme, avec des échanges réguliers avec le client, de la réflexion en amont, du
                                design, du développement, et des ajustements au fil de l'eau.
                            </TimelineText>
                            <TimelineIcon>🚀</TimelineIcon>
                        </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                        <TimelineDot />
                        <TimelineContent>
                            <TimelineDate>Septembre 2025</TimelineDate>
                            <TimelineTitle>Alternance Enedis & Mastère Ynov</TimelineTitle>
                            <TimelineText>
                                Après le développement du LMS pour Projets Miiro, j'étais en voie pour trouver de nouvelles 
                                opportunités. C'est alors que j'ai décroché une alternance chez Enedis en tant que 
                                Développeur Full-Stack. J'ai pu décrocher ce poste en démontrant mes compétences 
                                (notamment en présentant le LMS que j'ai réalisé en autonomie sur presque 1 an) ainsi que ma motivation.
                            </TimelineText>
                            <TimelineText>
                                J'ai déjà beaucoup appris depuis que j'ai rejoint Enedis en septembre 2025. Aussi, j'ai repris 
                                le chemin de l'école en intégrant Rouen Ynov Campus pour une formation de 2 ans de Mastère : 
                                Expert en développement Full-Stack. J'apprends énormément grâce à cette formation et 
                                avec mon rôle d'alternant chez Enedis, je vois des cas très concrets qui me forgent de l'expérience.
                            </TimelineText>
                            <TimelineIcon>⚡</TimelineIcon>
                        </TimelineContent>
                    </TimelineItem>

                    <TimelineItem>
                        <TimelineDot $current />
                        <TimelineContent>
                            <TimelineDate>Aujourd'hui</TimelineDate>
                            <TimelineTitle>En quête de nouveaux défis et maîtrise de ma stack</TimelineTitle>
                            <TimelineText>
                                Entre mon alternance chez Enedis et mon Mastère, mon quotidien est tourné vers la résolution de 
                                problématiques concrètes. Plutôt que de simplement suivre les tendances, je préfère éprouver mes 
                                outils sur le terrain pour en tirer une véritable expertise.
                            </TimelineText>
                            <TimelineText>
                                Je concentre actuellement mes efforts sur la solidité de mes développements avec Symfony 
                                et React, tout en optimisant mes workflows grâce à Docker. Mon passage par le design avec 
                                Figma me permet de garder une vision produit globale : je ne me contente pas de coder, je 
                                construis des solutions cohérentes, de la conception à l'infrastructure. 
                            </TimelineText>
                            <TimelineText>
                                Mon objectif ? Devenir un expert Full-Stack capable de porter des projets complexes 
                                de bout en bout.
                            </TimelineText>
                            <TimelineIcon>🌟</TimelineIcon>
                        </TimelineContent>
                    </TimelineItem>
                </TimelineContainer>
            </SectionCard>
            )}

            {/* Projets */}
            {activeSection === "projets" && (
            <SectionCard id="projets">
                <SectionTitle>Projets</SectionTitle>
                <ProfilText style={{ marginBottom: "30px" }}>
                    <p>
                        J'ai commencé à réaliser des projets dès mes études, ce qui m'a permis de développer le travail en
                        équipe, d'améliorer ma communication et d'adopter de bonnes pratiques de développement.
                    </p>
                    <p>
                        Plus récemment, j'ai mené à bien un projet de grande ampleur pour le développement complet d'un
                        système de gestion du suivi d'apprentissage (LMS), projet réalisé sur un an dans le respect de
                        l'évolution technique, du métier et capable à gérer un projet de bout en bout.
                    </p>
                    <p>
                        En parallèle, je travaille aussi en autonomie sur d'autres types de projets : création de sites web, cartes de
                        visite, brochures, flyers, etc.
                    </p>
                    <p>
                        Voici quelques exemples de réalisations dont je suis fier 👇
                    </p>
                </ProfilText>

                <ProjectsGrid>
                    <ProjectCard>
                        <ProjectImage>
                            <img src={AKSite} alt="Portfolio React" />
                        </ProjectImage>
                        <ProjectInfo>
                            <ProjectTitle>Portfolio - Site Web React</ProjectTitle>
                            <ProjectDescription>
                                Développement d'un site web Portfolio pour un développeur de jeux vidéos toujours en étude.
                                Son projet consiste à regrouper tous ces projets et à les partager facilement auprès de recruteurs ou d'écoles.
                                Nous avons discuté ensemble du bon format et j'ai pu réaliser ce projet, il y a même un système multilingue
                                avec de l'Anglais et du Français.
                            </ProjectDescription>
                            <ProjectDescription>
                                Tous les projets sont regroupés sur une même page, chaque projet peut être consulté avec des détails et
                                il y a en plus un système multilingue avec de l'Anglais et du Français.
                            </ProjectDescription>
                            <ProjectButton as="a" href="/projet/Portfolio_Alexandre_Kotowicz_React">
                                Détails sur le Portfolio
                            </ProjectButton>
                        </ProjectInfo>
                    </ProjectCard>

                    <ProjectCard>
                        <ProjectImage>
                            <img src={LMS} alt="LMS Projets Miiro" />
                        </ProjectImage>
                        <ProjectInfo>
                            <ProjectTitle>LMS - Outil de gestion de l'apprentissage</ProjectTitle>
                            <ProjectDescription>
                                Pendant un an, j'ai travaillé avec l'entreprise canadienne Projets Miiro sur un projet de grande
                                envergure : la création d'un LMS (Learning Management System), un outil de gestion de l'apprentissage
                                (ex : accès à des formations en ligne, suivi des progrès, attribution de rôles, gestion des plannings,
                                etc.).
                            </ProjectDescription>
                            <ProjectDescription>
                                Le site a été développé principalement en HTML, CSS et JavaScript, ce projet m'a permis de gérer
                                l'ensemble du cycle de développement : analyse des besoins, conception, validation, développement et tests.
                            </ProjectDescription>
                            <ProjectDescription>
                                C'est ce jour mon projet le plus complet, réalisé en grande partie en autonomie pour répondre à un
                                besoin concret de l'entreprise.
                            </ProjectDescription>
                            <ProjectButton as="a" href="/projet/LMS_Projets_Miiro">
                                Détails sur le LMS
                            </ProjectButton>
                        </ProjectInfo>
                    </ProjectCard>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                        <ProjectTitle>Mes autres projets</ProjectTitle>
                        <ProjectDescription>
                            Retrouvez l'ensemble de mes autres projets sur la page dédiée
                        </ProjectDescription>
                        <ProjectButton as="a" href="/Projets" style={{ marginTop: "15px", display: "inline-block" }}>
                            Voir tous mes projets
                        </ProjectButton>
                    </div>
                </ProjectsGrid>
            </SectionCard>
            )}

            {/* Compétences */}
            {activeSection === "competences" && (
            <SectionCard id="competences">
                <SectionTitle>Compétences</SectionTitle>
                <ProfilText style={{ marginBottom: "30px" }}>
                    Au fil de mes projets, que ce soit en équipe pendant mes études, en collaboration avec des entreprises ou
                    en solo, j'ai pu développer un panel de compétences variées.
                </ProfilText>

                <CompetencesContent>
                    <CompetenceCategory>
                        <h3>Compétences techniques</h3>
                        <ul>
                            <li><strong>Développement web :</strong> HTML, CSS, JavaScript, PHP, React</li>
                            <li><strong>CMS & e-commerce :</strong> PrestaShop, WordPress</li>
                            <li><strong>Base de données :</strong> mySQL, gestion de bases de données</li>
                            <li><strong>Programmation :</strong> développement orienté objet</li>
                            <li><strong>Design & conception :</strong> Figma, identité visuelle, maquettes, design responsive</li>
                            <li><strong>Méthodologie :</strong> Analyse des besoins, logique métier, gestion de contraintes, implémentation précise</li>
                        </ul>

                        <p style={{ marginTop: "20px", fontStyle: "italic" }}>
                            Par exemple, pour le projet LMS développé pour Projets Miiro, j'ai conçu toute la structure du système :
                            base de données, logique métier, gestion des utilisateurs, gestion des plannings, etc.
                        </p>

                        <p style={{ fontStyle: "italic" }}>
                            En parallèle, d'autres projets (sites vitrine, cartes de visite, brochures...), j'ai travaillé sur la partie
                            graphique et l'expérience utilisateur.
                        </p>

                        <LogosGrid>
                            <img src={FigmaLogo} alt="Figma" />
                            <img src={ReactLogo} alt="React" />
                            <img src={MySQLLogo} alt="MySQL" />
                            <img src={JSLogo} alt="JavaScript" />
                            <img src={PHPLogo} alt="PHP" />
                            <img src={PrestaShopLogo} alt="PrestaShop" />
                            <img src={SymfonyLogo} alt="WordPress" />
                        </LogosGrid>
                    </CompetenceCategory>

                    <SoftSkills>
                        <h3>Soft-skills</h3>
                        <ul>
                            <li>Travail en équipe et bonne communication (projets de groupe)</li>
                            <li>Gestion du stress et respect des délais</li>
                            <li>Autonomie et sens de l'organisation</li>
                            <li>Capacité d'adaptation selon les besoins</li>
                            <li>Méthodes agiles et adaptabilité au contexte</li>
                        </ul>

                        <p style={{ marginTop: "20px" }}>
                            Je prends le temps de bien faire les choses, de comprendre les attentes, et je m'investis à fond dans
                            chaque projet, petit ou grand.
                        </p>
                    </SoftSkills>
                </CompetencesContent>
            </SectionCard>
            )}

            {/* CV */}
            {activeSection === "cv" && (
            <SectionCard id="cv">
                <SectionTitle>CV</SectionTitle>
                <CVContent>
                    <CVPreview>
                        <img src={CVImage} alt="Aperçu du CV" />
                    </CVPreview>
                    <CVInfo>
                        <CVText>
                            Retrouvez mon parcours complet, mes expériences professionnelles et académiques,
                            ainsi que mes formations dans mon CV détaillé.
                        </CVText>
                        <DownloadButton href="/pdf/CV_Leo_Langlois.pdf" download>
                            Télécharger mon CV
                        </DownloadButton>
                    </CVInfo>
                </CVContent>
            </SectionCard>
            )}

            {/* Contact */}
            {activeSection === "contact" && (
            <SectionCard id="contact">
                <SectionTitle>Contact</SectionTitle>
                <ContactContent>
                    <ContactItem>
                        <ContactIcon>📧</ContactIcon>
                        <div>
                            <strong>Contact perso :</strong> langlois76190@gmail.com
                        </div>
                    </ContactItem>
                    <ContactItem>
                        <ContactIcon>📧</ContactIcon>
                        <div>
                            <strong>Contact freelance / pro :</strong> clipweb.info@gmail.com
                        </div>
                    </ContactItem>
                    <ContactItem>
                        <ContactIcon>📱</ContactIcon>
                        <div>(+33) 07 82 74 09 96</div>
                    </ContactItem>
                    <ContactItem>
                        <ContactIcon>💼</ContactIcon>
                        <div>
                            <a
                                href="https://www.linkedin.com/in/leo-langlois"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: colors.dark_red, textDecoration: "none" }}
                            >
                                LinkedIn
                            </a>
                        </div>
                    </ContactItem>
                    <ContactNote>
                        Je suis disponible 7 jours sur 7 et je réponds rapidement.
                        Si vous préférez échanger par téléphone, vous pouvez soit m'envoyer un mail avec votre numéro pour
                        que l'on fixe un créneau, soit m'appeler directement (même si je suis parfois moins disponible pour
                        répondre immédiatement).
                    </ContactNote>
                </ContactContent>
            </SectionCard>
            )}
        </PageContainer>
    );
}

export default Portfolio;